module.exports = __webpack_public_path__ + "img/AT0000000674745.b8bdf580.png";